import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CollectionFormField } from 'src/models/ts/collection-form-field.model';
import { TimeRangeUnitType } from 'src/models/ts/time-range-unit-type.model';
import { TranslationService } from 'src/app/core/services/translation/translation.service';

@Component({
  selector: 'bizz-report-timerange-control',
  standalone: true,
  imports: [],
  templateUrl: './report-timerange-control.component.html',
  styleUrl: './report-timerange-control.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTimerangeControlComponent {
  public field = input.required<CollectionFormField>();
  private translationService = inject(TranslationService);

  public dateUnitTypes = [
    { caption: 'TimeRangeUnitType.Hours', value: TimeRangeUnitType.Hours },
    { caption: 'TimeRangeUnitType.Days', value: TimeRangeUnitType.Days },
    { caption: 'TimeRangeUnitType.Weeks', value: TimeRangeUnitType.Weeks },
    { caption: 'TimeRangeUnitType.Months', value: TimeRangeUnitType.Months },
    { caption: 'TimeRangeUnitType.Years', value: TimeRangeUnitType.Years }

  ];

  public displayValue = computed(() => {
    const field = this.field();
    if(field == null || field.Value == null || field.Value.Value == null || field.Value.UnitType == null) {
      return '';
    }

    return `${field.Value?.Value} ${this.translationService.translate(this.dateUnitTypes.find(dt => dt.value === field.Value?.UnitType)?.caption || '')}`;
  })
}
